import { createSelector } from '@reduxjs/toolkit';
import { selectFloors } from 'reduxStore/floors/selectors';

//📌 Selector for get all sites from orgID
export const selectSites = createSelector(
	[(state) => state.Sites.data, (state) => state.Auth.selectedProfile.orgID],
	(sitesData, orgID) => sitesData[orgID] || []
);

//📌 Selector for get site by orgID and siteID
export const selectSiteByOrgAndSiteID = createSelector(
	[(state) => state.Sites.data, (state) => state.Auth.selectedProfile.orgID, (_, siteID) => siteID],
	(sitesData, orgID, siteID) => (sitesData[orgID] || []).find((site) => site.siteID === siteID) || null
);

//📌 Selector for get all sites by name
export const selectSitesByName = createSelector(
	[(state) => state.Sites.data, (state) => state.Auth.selectedProfile.orgID, (_, name) => name],
	(sitesData, orgID, name) =>
		(sitesData[orgID] || []).filter((site) => site.name.toLowerCase().includes(name.toLowerCase())) || []
);

// 📌 Selector to merge sites with their respective floors
export const selectSitesWithFloors = createSelector([selectSites, selectFloors], (sites, floors) => {
	// Map through each site and attach floors that match the siteID
	return sites.map((site) => ({
		...site,
		floors: floors.filter((floor) => floor.siteID === site.siteID) // Get only floors belonging to this site
	}));
});

// 📌 Selector for the last created Site in the current org
export const selectLastCreatedSite = createSelector(
	[(state) => state.Sites.data, (state) => state.Auth.selectedProfile.orgID],
	(sitesData, orgID) => {
		const sites = sitesData[orgID] || [];
		return sites.length > 0 ? sites[sites.length - 1] : null;
	}
);
